// Copyright (c) 2019 Verimatrix, Inc.  All Rights Reserved.

import React, {Component} from 'react'

import './index.css'

export default class MySolutions extends Component {
  renderSolutions = (name, status) => {
    return (
      <div className='row solution'>
        <div className='col-md-2 offset-md-2'>
          {name}
        </div>
        <div className='col-md-7 solution-status'>
          {status}
        </div>
      </div>
    )
  }

  render () {
    return (
      <div className='my-solutions'>
        {this.renderSolutions('Multi DRM', 'View Only')}
        {this.renderSolutions('Analytics', 'Admin')}
      </div>
    )
  }
}
